import {downloadFile} from '@domain/file-download'
import {TaskSource} from '@domain/tasks/src/types'
import {ApiClient} from '@hconnect/apiclient'
import {AppName} from '@hconnect/common/hproduce'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'
import qs from 'qs'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../consts'
import {TaskFilterDto, TasksSortingOptions} from '../../types'

type ExportToExcelPayload = TasksSortingOptions & {
  sources: TaskSource[]
  filters?: TaskFilterDto
}

const APP_NAME: AppName = 'HProduce'
const DATE_FORMAT = 'YYYY-MM-DD'

export const useExportToExcel = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<Blob, AxiosError, ExportToExcelPayload>({
    mutationFn: async ({sources, sortBy, sortOrder, filters}) => {
      const response = await ApiClient.axiosInstance.post<Blob>(
        `${TasksApiPath.TASKS}/export-tasks-to-excel`,
        filters,
        {
          params: {sources, sortBy, sortOrder},
          paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat'}),
          responseType: 'blob'
        }
      )

      return response.data
    },
    onError: () => {
      spawnErrorToast(t('task.message.exportFailed'))
    },
    onSuccess: (data) => {
      const fileName = `${moment().format(DATE_FORMAT)}_${APP_NAME}_${t('pageTitle')}.xlsx`
      downloadFile(data, fileName)
    }
  })
}
